import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Organization } from '../../core/models/organization.model';

@Injectable({
  providedIn: 'root'
})
export class OrganizationStore {
  organization: BehaviorSubject<Organization> = new BehaviorSubject<Organization>(null);
  organizations: any[];
}
